// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile-technics {
    border-radius: 14px;
}

.profile-technics__new-button {
    background: var(--white-color);
    border-radius: 2px;
}

.profile-technics__new-button:hover {
    /* background: var(--hover-pb-bg-color); */
    cursor: pointer;
}

.profile-technics__team {
    display: flex;
    margin-top: var(--space);
}
.profile-technics__team__icon {
    width: var(--space-and-half);
    height: var(--space-and-half);
    margin-right: var(--space-half);
}
.profile-technics__team__icon .icon-ball{
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));
    color: var(--white-color);
}
.profile-technics__data {
    margin-top: var(--space);
    display: grid;
    grid-gap: var(--space-and-half);
    grid-template-columns: repeat(5, 1fr);
}
.profile-technics__data__positions-graph {
    grid-column-start: 1;
    grid-column-end: 3;
}
.profile-technics__data__positions-graph__field {}
.profile-technics__data__positions-graph__field img {
    width: 100%;
}
.profile-technics__data__info {
    grid-column-start: 3;
    grid-column-end: end;
}
.profile-technics__data__info__statistics {}
.profile-technics__data__info__attributes {}
.profile-technics__data__info__attributes__content{
    display: flex;
    justify-content: space-between;
    margin-right: var(--space);
}
.profile-technics__data__info__attributes__attribute {
    margin-bottom: var(--space-and-half);
}

.profile-technics__data__info__attributes__attribute__label .hubicon-edit::before{
    margin-left: 12px;
    color: var(--new-green-color);
    cursor: pointer;
}

.profile-technics__data__info__attributes__attribute__value.baloa-normal-medium{
    cursor: pointer;
    color: var(--new-green-color);    
}
.color-text{
    color: var(--primary-dark-color) !important;
}
.color-text-title{
    color: var( --basic-gray-color) !important;
}
.color-text-subtitle{
    color: var(--primary-very-dark-color) !important;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-technics__data {
        grid-gap: 16px;
    }
    .profile-technics__data__positions-graph {
        grid-column-start: 1;
        grid-column-end: 4;
    }
    .profile-technics__data__info {
        grid-column-start: 4;
        /* margin-top: var(--space-x2); */
    }
    .profile-technics__data__info__attributes__content {
        flex-direction: column;
    }
    .profile-technics__team {
        display: none;     
    }    

    .baloa-card-1.profile-technics.profile__technics {
        padding: 12px 16px;
        margin-right: 10px;
        margin-left: 10px;
        border-radius: 14px;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-technics/ProfileTechnicsComponent.style.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;AACnC;AACA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,aAAa;IACb,+BAA+B;IAC/B,qCAAqC;AACzC;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;AACA,iDAAiD;AACjD;IACI,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,oBAAoB;AACxB;AACA,2CAA2C;AAC3C,2CAA2C;AAC3C;IACI,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;AAC9B;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,gDAAgD;AACpD;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;IAClB;IACA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;IACA;QACI,oBAAoB;QACpB,iCAAiC;IACrC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QACnB,2CAA2C;IAC/C;AACJ","sourcesContent":["\n.profile-technics {\n    border-radius: 14px;\n}\n\n.profile-technics__new-button {\n    background: var(--white-color);\n    border-radius: 2px;\n}\n\n.profile-technics__new-button:hover {\n    /* background: var(--hover-pb-bg-color); */\n    cursor: pointer;\n}\n\n.profile-technics__team {\n    display: flex;\n    margin-top: var(--space);\n}\n.profile-technics__team__icon {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    margin-right: var(--space-half);\n}\n.profile-technics__team__icon .icon-ball{\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));\n    color: var(--white-color);\n}\n.profile-technics__data {\n    margin-top: var(--space);\n    display: grid;\n    grid-gap: var(--space-and-half);\n    grid-template-columns: repeat(5, 1fr);\n}\n.profile-technics__data__positions-graph {\n    grid-column-start: 1;\n    grid-column-end: 3;\n}\n.profile-technics__data__positions-graph__field {}\n.profile-technics__data__positions-graph__field img {\n    width: 100%;\n}\n.profile-technics__data__info {\n    grid-column-start: 3;\n    grid-column-end: end;\n}\n.profile-technics__data__info__statistics {}\n.profile-technics__data__info__attributes {}\n.profile-technics__data__info__attributes__content{\n    display: flex;\n    justify-content: space-between;\n    margin-right: var(--space);\n}\n.profile-technics__data__info__attributes__attribute {\n    margin-bottom: var(--space-and-half);\n}\n\n.profile-technics__data__info__attributes__attribute__label .hubicon-edit::before{\n    margin-left: 12px;\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.profile-technics__data__info__attributes__attribute__value.baloa-normal-medium{\n    cursor: pointer;\n    color: var(--new-green-color);    \n}\n.color-text{\n    color: var(--primary-dark-color) !important;\n}\n.color-text-title{\n    color: var( --basic-gray-color) !important;\n}\n.color-text-subtitle{\n    color: var(--primary-very-dark-color) !important;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-technics__data {\n        grid-gap: 16px;\n    }\n    .profile-technics__data__positions-graph {\n        grid-column-start: 1;\n        grid-column-end: 4;\n    }\n    .profile-technics__data__info {\n        grid-column-start: 4;\n        /* margin-top: var(--space-x2); */\n    }\n    .profile-technics__data__info__attributes__content {\n        flex-direction: column;\n    }\n    .profile-technics__team {\n        display: none;     \n    }    \n\n    .baloa-card-1.profile-technics.profile__technics {\n        padding: 12px 16px;\n        margin-right: 10px;\n        margin-left: 10px;\n        border-radius: 14px;\n        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
